import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirmDelete: 'Yes, delete this client',
    modalSubtitle: '**{0}** invoices will no longer be available.',
    modalTitle: 'Remove {0} from your clients list?',
    successMessage: 'Your client {0} has been successfully deleted.',
    successTitle: 'Your client has been deleted',
  },
  fr: {
    cancel: 'Annuler',
    confirmDelete: 'Oui, supprimer ce client',
    modalSubtitle: 'Les factures de **{0}** ne seront plus disponibles.',
    modalTitle: 'Supprimer {0} de votre liste de clients ?',
    successMessage: 'Votre client {0} a bien été supprimé',
    successTitle: 'Votre client a été supprimé',
  },
} as const);

export default locales;
